<template>
  <section class="hero">
    <!-- Image Section -->
     <div id="hero-box">     
      <div class="hero-image">
      <img src="@/assets/Duda_LOGO_SW.png" alt="Logo">
      <!-- <p id="duda">DU <br> DA</p> -->
    </div>
    <!-- Text Section -->
    <div class="hero-text">
      <h1>Dein <u id="prs">persönlicher</u> IT-Service in Bielefeld Quelle</h1>

      <a href="/services" class="cta-button">Termin jetzt buchen ➜</a>
    </div></div>

  </section>
</template>

<script>
export default {
  name: 'HeroSection',
};
</script>

<style scoped>

#prs{
  text-decoration-color: #ff793b;
  font-style: italic;
}

#hero-box{
  background-color: rgba(0, 1, 54, 0.158);
  border-radius: 40px;
box-shadow: 0 0 10px rgba(0, 0, 0, 0.685); /* Initial subtle glow */

display: flex;
  justify-content: center;

  align-items: center;
  height: 700px; 
  gap: 5%;
  max-width: 80%;

  margin: auto;
  margin-bottom: rem;

  border: 1px solid black
}

.hero {
  font-family: "Overpass", serif;
  font-optical-sizing: auto;
  font-weight: <weight>;
  font-style: normal;
  font-weight: 400;
  font-style: normal;
  
  display: flex;
  justify-content: center;
  
  
    height: 95vh;
    width: 100%;

  
}



.hero-text {
  flex: 1;
  text-align: right;
  padding-right: 5rem;
  color: white;
  padding-bottom: 1.5rem; /* Prevents margin collapse */
  max-width: 500px;

}

.hero-image {

  flex: 1;
  text-align: center;
 max-width: 600px;
 padding: 0px 3rem;

}

.hero-image img {
  max-width: 100%;
  height: auto;
}

h1 {
  font-size: 4.5rem;
}

p {
  font-size: 2.25rem;
}

.cta-button {
  margin-top: 2rem;
  padding: 1rem 2rem;
  background-color: rgba(0, 0, 0, 0.555);
  color: white;
  text-decoration: none;
  border-radius: 100px;
  font-size: 1.5rem;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.685); /* Initial subtle glow */
}

.cta-button:hover {
  background-color: rgba(43, 64, 253, 0.84);
  box-shadow: 0 0 20px rgba(43, 64, 253, 0.8); /* Enhanced glow on hover */
  transform: scale(1.05); /* Slightly enlarges the button */
}

#duda {
  
  color: white;
  font-weight: bold; /* Optional: make "DUDA" stand out */
  font-size: 9rem; /* Optional: adjust font size for "DUDA" */
}
</style>
